<div class="container-right-main fluid-container">
    <div class="top-right-div">
    <div class="top-row">
        <div class="left-titl-buton ">
            <div class="title">
               Data Source
            </div>
        </div>
        <div class="manual-div">
        </div>
    </div>
    <div class="sec-row">
        <div class="sr-left-div">
        </div>
        <!-- <div class="right-filter">
            <input matInput #searchInput  placeholder="Search with ..." class="filter-search" (input)="applyFilter(searchInput.value)">
            <i class="fa fa-search search-icon"></i>
        </div>
        <div *ngIf="showNoSearchResultsMessage">
            No search results found.
        </div> -->
    </div>
    <div class="d-flex align-right">
        <button (click)="openCreateSourceDialog()" class="btn-white">+ New Data Source</button>
    </div>
    <div class="bottom-table">
        <div class="overflowxauto">
            <table class="assignee-table mat-elevation-z7" mat-table [dataSource]="dataSource" matSort (matSortChange)="sortData($event)">
                <ng-container matColumnDef="sharepoint_path_id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        ID
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td" (click)="showDetails(element)" class="clickable-row"> {{element.sharepoint_path_id}} </td>
                  </ng-container>
 
                  <!-- <ng-container matColumnDef="sharepoint_path_id">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        sharepoint_path_id
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{element.sharepoint_path_id}} </td>
                  </ng-container> -->
                  <!-- <ng-container matColumnDef="source_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Source name
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="showDetails(element)" class="clickable-row tab-td"> {{element.source_name}} </td>
                  </ng-container> -->
                    <ng-container matColumnDef="source_path">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Source path
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="showDetails(element)" class="clickable-row  tab-td"> {{element.source_path}} </td>
                  </ng-container>
 
                  <ng-container matColumnDef="product_name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Source Name
                    </th>
                    <td mat-cell *matCellDef="let element" (click)="showDetails(element)" class="clickable-row tab-td"> {{element.product_name}} </td>
                  </ng-container>
 
                  <ng-container matColumnDef="created_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Added on
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ convertUtcToLocal(element.created_date) | date: 'MM-dd-yyyy hh:mm a' }} </td>
                  </ng-container>
                  <ng-container matColumnDef="updated_date">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Last modified
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ convertUtcToLocal(element.updated_date) | date: 'MM-dd-yyyy hh:mm a' }}</td>
                  </ng-container>
                  <ng-container matColumnDef="region">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Region
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{element.region}}</td>
                  </ng-container>
                  <ng-container matColumnDef="primary_market">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Primary Market
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.primary_market }}</td>
                  </ng-container>
                  <ng-container matColumnDef="product_group">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Product Group
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.product_group }}</td>
                  </ng-container>
                  <ng-container matColumnDef="is_internal">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Is Internal
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.is_internal }}</td>
                  </ng-container>
                  <ng-container matColumnDef="copy_approved">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by number"  class="tab-th">
                        Copy Approved
                    </th>
                    <td mat-cell *matCellDef="let element" class="tab-td"> {{ element.copy_approved }}</td>
                  </ng-container>
                <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
 
            </table>
        </div>     
    </div>
    <mat-paginator [pageSizeOptions]="[5, 10, 15, 20]" showFirstLastButtons aria-label="Select page of periodic elements">
    </mat-paginator>
</div>
</div>